import React, { useMemo, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import "./Admin.css";
import { ADMIN_NAV_SECTIONS, getModuleByKey } from "./adminConfig";
import { adminLogout } from "./AdminGuard";
import NotificationBell from "../User/Components/Notification/NotificationBell";

const AdminLayout = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [navQuery, setNavQuery] = useState("");
  const adminUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("adminUser") || "{}");
    } catch {
      return {};
    }
  })();

  const closeSidebar = () => setSidebarOpen(false);

  const filteredSections = useMemo(() => {
    const q = navQuery.trim().toLowerCase();
    if (!q) return ADMIN_NAV_SECTIONS;

    return ADMIN_NAV_SECTIONS.map((section) => {
      if (section.links) {
        const links = section.links.filter((l) => l.label.toLowerCase().includes(q));
        return links.length ? { ...section, links } : null;
      }
      const moduleKeys = (section.moduleKeys || []).filter((key) => {
        const mod = getModuleByKey(key);
        return mod?.label.toLowerCase().includes(q);
      });
      return moduleKeys.length ? { ...section, moduleKeys } : null;
    }).filter(Boolean);
  }, [navQuery]);

  return (
    <div className="admin-root admin-layout">
      {sidebarOpen && (
        <button
          type="button"
          className="admin-overlay"
          aria-label="Close menu"
          onClick={closeSidebar}
        />
      )}
      <aside className={`admin-sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="admin-sidebar-head">
          <h2>Cars Admin</h2>
          <span>{adminUser.email || "Administrator"}</span>
        </div>
        <div className="admin-nav-search">
          <input
            type="search"
            placeholder="Search menu…"
            value={navQuery}
            onChange={(e) => setNavQuery(e.target.value)}
            aria-label="Search admin menu"
          />
        </div>
        <nav className="admin-nav">
          {filteredSections.map((section) => (
            <div className="admin-nav-group" key={section.title}>
              <div className="admin-nav-group-title">{section.title}</div>
              {section.links?.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.end}
                  onClick={closeSidebar}
                >
                  {link.label}
                </NavLink>
              ))}
              {section.moduleKeys?.map((key) => {
                const mod = getModuleByKey(key);
                if (!mod) return null;
                return (
                  <NavLink
                    key={mod.key}
                    to={`/admin/${mod.key}`}
                    onClick={closeSidebar}
                  >
                    {mod.label}
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>
        <div className="admin-sidebar-foot">
          <button
            type="button"
            className="admin-btn admin-btn-ghost"
            style={{ width: "100%" }}
            onClick={() => adminLogout(navigate)}
          >
            Logout
          </button>
        </div>
      </aside>
      <div className="admin-main">
        <header className="admin-topbar">
          <button
            type="button"
            className="admin-menu-toggle"
            aria-label="Open menu"
            onClick={() => setSidebarOpen(true)}
          >
            ☰
          </button>
          <h1>Administration</h1>
          <NotificationBell />
          <button
            type="button"
            className="admin-btn admin-btn-ghost"
            onClick={() => navigate("/")}
          >
            View Site
          </button>
        </header>
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
